// React
import React from 'react';
// External libraries
import {
    Col, Container, Image, Row
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
// Internal
import LoginForm from 'components/auth/FormLogin';
import config from 'config/config';
import BrandService from 'services/brand';
import resolveBrandFromHostname from 'utils/resolveBrandFromHostname';
// Styles
import './styles.scss';
// Images
import paw from 'assets/images/paw.png';

const DEFAULT_HEADING = 'Enter your account username and password below to log into the Vet Portal.';

const BRAND_HEADINGS = Object.freeze({
    Lawnswood: 'Enter your account username and password below to log into the Lawnswood Vet Portal.',
    Edenhills: 'Enter your account username and password below to log into the Edenhills Vet Portal.',
    'Pets in Peace': 'Enter your account username and password below to log into the Pets in Peace Vet Portal.',
    'Patch & Purr': 'Enter your account username and password below to log into the Patch & Purr Vet Portal.',
    'Pets at Peace CW': 'Enter your account username and password below to log into the Pets at Peace CW Vet Portal.'
});

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.location = props.location;
        this.hideNav = props.hideNav === true ? 'hide' : ' ';
        // Resolved from the hostname so that an unknown or unbranded host falls
        // back to the neutral heading instead of another brand's.
        const brand = resolveBrandFromHostname(window.location.hostname) || (config.BRAND ?? '');
        
        this.state = {
            imgSrc: '',
            // Set up-front: the heading must not depend on the brand lookup,
            // which is skipped entirely when there is no brand to look up.
            headingMessage: BRAND_HEADINGS[brand] ?? DEFAULT_HEADING
        };
        this.getBrandImage(brand);
    }

    /**
     * Gets the brand logo to display in the app.
     * No-ops when the portal is unbranded, as there is nothing to look up.
     *
     * @param {string} brand - The brand resolved for the current host
     */
    getBrandImage(brand) {
        if (!brand) {
            return;
        }

        BrandService.getBrand(brand)
            .then((response) => {
                const logoUrl = response?.data?.cstm?.brand_logo_url_c;

                if (logoUrl) {
                    this.setState({ imgSrc: logoUrl });
                }
            }).catch((err) => {
                console.error(err);
            });
    }

    render() {
        return (
            <Container fluid className="login-page-wrapper">
                <Row className="login-page">
                    <Col className="left-section" md="auto" />
                    <Col className="right-section">
                        <div className="login-form-wrapper">
                            <div className="logo-wrapper">
                                {
                                    this.state.imgSrc && (
                                        <Image
                                            alt={config.webTitle}
                                            src={this.state.imgSrc}
                                            className="login-logo"
                                            height="40"
                                        />
                                    )
                                }
                            </div>

                            <div className="heading-wrapper">
                                <h1 className="page-heading">Welcome to our Vet Portal</h1>
                                <p className="inline-block-below-lg">
                                    {this.state.headingMessage}
                                </p>
                            </div>

                            <div className="form-wrapper">
                                {
                                    typeof (this.props.match.params.bookingId) === 'undefined'
                                    && typeof (this.props.match.params.quotedProductId) === 'undefined'
                                        ? (<LoginForm />) : (
                                            <LoginForm
                                                bookingId={this.props.match.params.bookingId}
                                                quotedProductId={this.props.match.params.quotedProductId}
                                            />
                                        )
                                }
                            </div>
                            <Image alt="Pet paw" src={paw} className="image-paw" />
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(Login);
